import { useLocation, useNavigate } from "react-router"
import { Link } from "react-router-dom"
import AssignmentComponent from "../../../Assignment/AssignmentComponent"
import styles from "../styles.module.scss"
import { TeacherGradesState } from "../GradeList/TeacherGrades"
import { AssignmentContext, AssignmentContextType, AssignmentSection } from "components/Assignment/AssignmentContext"
import { TeacherAssignmentResponse } from "../../../../shared/types/teacherTypes"
import { LessonResponse } from "shared/lessons"
import React, { useEffect } from "react"
import moduleRoutes from "shared/routes/moduleRoutes"
import DocumentDropdown from "components/Dashboards/Teacher/Assignments/DocumentDropdown"
import { Button } from "react-bootstrap"
import ToolTip from "components/General/ToolTip"
import PreviewReviewAssignment from "components/Dashboards/Teacher/Assignments/PreviewReviewAssignment"
import { BlockType } from "shared/types/science35Types"
import { toProductString } from "helpers/blockStringConverter"

export class AssignmentPreviewStateProps { // class so that route state helper function can read all properties
    constructor() {
        this.lesson = null
        this.blockType = null
    }
    assignment: TeacherAssignmentResponse
    lesson?: LessonResponse
    origin: "grades" | "assignments"
    blockType?: BlockType
}
/**
 * @abstract Renders assignment preview
 * NOTE: Currently being used when teacher clicks on assignment and then clicks "View Assignment"
 */
export default function Preview() {
    const location = useLocation()
    const state = location.state as AssignmentPreviewStateProps

    const navigate = useNavigate()

    const assessmentOnly = !state.assignment?.topicId && state.assignment.assessmentId && !state.assignment.lessonId
    const isReviewAssignment = state.assignment.lessonVariety === "Review" && Boolean(state.assignment.review)
    // if it has assessment but no lesson, than its assessment only assignment
    const [activePart, setActivePart] = React.useState<AssignmentSection>(state.assignment?.topicId ? "topic" : (assessmentOnly) ? "assessment" : "lesson")

    const TeacherGradesState: TeacherGradesState = {
        assignment: state.assignment,
        lesson: state.lesson
    }
    const assignmentValues: AssignmentContextType = {
        activePart: activePart,
        setActivePart: setActivePart,
        moduleName: state.lesson?.moduleName || state.assignment.moduleName,
        lessonVariety: state.assignment.lessonVariety,
        type: state.lesson?.type || state.assignment.pureInquiryType,
        guidedLesson: state.lesson,
        assessmentOnly: assessmentOnly,
        demoMode: false,
        reworkAssignmentMode: false,
        isReview: false,
    }

    const goDemo = () => {
        navigate(`/dashboard/teacher/assignments/${state.assignment.id}/demo-mode`,
            {
                state: {
                    assignment: state.assignment
                }
            }
        )
    }

    useEffect(() => {
        moduleRoutes.checkModuleAccess(state.lesson?.moduleName ?? undefined)
        .then(userHasAccess => {
            if (!userHasAccess) {
                return window.location.href = `/simulations/moduleName=${state.lesson?.moduleName}/tab=challenge`
            }
        })
    }, [state.lesson?.moduleName])

    return <>
        <div className="d-grid gap-3 d-md-flex justify-content-between align-items-center mb-1">
            <Link
                style={{
                    "textDecoration": "none"
                }}
                to={state.origin === "assignments" ? (isReviewAssignment ? `/dashboard/teacher/science/${toProductString(state?.blockType)}/assignments` : "/dashboard/teacher/assignments") : "../"}
                state={TeacherGradesState}
            >
                <i className="fas fa-arrow-left" /> Return to {state.origin === "assignments" ? "Assignments" : "Submissions"}
            </Link>
            {!isReviewAssignment && 
                <ToolTip title="Demonstrate the assignment using the student interface">
                    <Button variant="primary" className="ms-md-auto me-2" onClick={goDemo}>Demo Mode</Button>
                </ToolTip>}
            <DocumentDropdown
                topicId={state.assignment?.topicId}
                assessmentId={state.assignment.assessmentId}
                lessonId={state.assignment.lessonId}
            />
        </div>

        {isReviewAssignment && 
            <PreviewReviewAssignment
                assignment={state.assignment}
             />}
             
        {!isReviewAssignment && 
            <div className={styles.previewBottom}>
                <AssignmentContext.Provider value={assignmentValues}>
                    <AssignmentComponent
                        topicId={state.assignment?.topicId}
                        assessmentId={state.assignment.assessmentId}
                        moduleName={state.lesson?.moduleName || state.assignment.moduleName}
                        assessmentNumber={state.assignment.assessment?.number}
                        lessonVariety={state.assignment.lessonVariety}
                        type={state.assignment.type}
                        oneQuestionMode={state.assignment.oneQuestionMode}
                        randomizable={state.assignment.randomizable}
                        goBack={() => navigate("/dashboard/teacher/assignments")}
                    ></AssignmentComponent>
                </AssignmentContext.Provider>
            </div>}
    </>
}
